import { Link } from "react-router-dom";
import NoteService from "../service/NoteService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNoteSticky } from "@fortawesome/free-regular-svg-icons/faNoteSticky";

const Component = ({ className, noteTargetPath, noteTargetId }) => {
  const route = NoteService.createNoteRouteUrl(noteTargetPath, noteTargetId);

  return (
    <span className={className + " "}>
      <Link style={{}} to={route}>
        <FontAwesomeIcon icon={faNoteSticky} />
      </Link>
    </span>
  );
};

export default Component;
